import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

function Details() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
   fetch(`https://student-backend-infs-202.onrender.com/students/${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Student not found or server error");
        }
        return res.json();
      })
      .then((data) => {
        console.log("STUDENT DATA:", data);
        setStudent(data);
      })
      .catch((err) => {
        console.log("FETCH ERROR:", err.message);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  }, [id]);

  // ---------------- SAFE STATES ----------------

  if (loading) {
    return <p style={styles.loading}>Loading student...</p>;
  }

  if (error) {
    return (
      <p style={{ textAlign: "center", color: "red" }}>
        {error}
      </p>
    );
  }

  if (!student) {
    return (
      <p style={{ textAlign: "center" }}>
        No student data found
      </p>
    );
  }

  // ---------------- SAFE DATA EXTRACTION ----------------

  const name = student?.FullName || student?.name || "Unknown Student";
  const course = student?.Course || student?.course || "N/A";
  const studentId = student?.StudentID || student?.id || "N/A";

  // ---------------- UI ----------------

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.avatar}>
            {String(name || "?").charAt(0).toUpperCase()}
          </div>

          <div>
            <h2 style={styles.name}>{name}</h2>
            <p style={styles.id}>Student ID: #{studentId}</p>
          </div>
        </div>

        {/* COURSE */}
        <div style={styles.section}>
          <span style={styles.badge}>{course}</span>
        </div>

        <hr style={styles.line} />

        {/* INFO */}
        <h3>Student Info</h3>

        <div style={styles.infoBox}>
          <p><strong>Status:</strong> Active</p>
          <p><strong>Year:</strong> 1</p>
          <p>
  <strong>DOB:</strong>{" "}
  {student.DOB ? new Date(student.DOB).toLocaleDateString() : "N/A"}
</p>
<p><strong>Gender:</strong> {student.Gender}</p>
<p><strong>Contact:</strong> {student.Contact}</p>
<p><strong>Residence:</strong> {student.Residence}</p>
          <p><strong>Date Added:</strong> {new Date().toLocaleDateString()}</p>
        </div>

        {/* BACK BUTTON */}
        <p style={styles.backText} onClick={() => navigate(-1)}>
          ← Go back to list
        </p>

      </div>
    </div>
  );
}

// ---------------- STYLES ----------------

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#f3f4f6",
  },

  card: {
    width: "400px",
    background: "white",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
  },

  avatar: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "black",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "22px",
    fontWeight: "bold",
  },

  name: {
    margin: 0,
  },

  id: {
    margin: 0,
    color: "gray",
  },

  section: {
    marginTop: "15px",
  },

  badge: {
    padding: "5px 10px",
    background: "#e5e7eb",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "bold",
  },

  line: {
    margin: "20px 0",
  },

  infoBox: {
    lineHeight: "1.8",
  },

  backText: {
    marginTop: "20px",
    color: "blue",
    cursor: "pointer",
    textDecoration: "underline",
    fontSize: "14px",
  },

  loading: {
    textAlign: "center",
    marginTop: "50px",
  },
};

export default Details;